export const brivioLogo = (color: string = 'currentColor') => {
	return (
		<svg
			width="100%"
			height="100%"
			viewBox="0 0 320 320"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g filter="url(#filter0_d_32_279)">
				<path
					d="M284 32C286.209 32 288.003 33.7912 287.969 36C287.465 68.2566 280.868 100.14 268.513 129.967C255.648 161.026 236.791 189.248 213.019 213.019C189.248 236.791 161.026 255.648 129.967 268.513C100.14 280.868 68.2566 287.465 36 287.969C33.7912 288.003 32 286.209 32 284V219.592C32 217.383 33.7912 215.597 35.9998 215.549C58.7468 215.053 81.2159 210.333 102.258 201.617C124.532 192.391 144.771 178.868 161.82 161.819C178.868 144.771 192.391 124.532 201.617 102.258C210.333 81.2159 215.053 58.7468 215.549 35.9998C215.597 33.7912 217.383 32 219.592 32H284Z"
					fill={color}
				/>
			</g>
			<defs>
				<filter
					id="filter0_d_32_279"
					x="28"
					y="32"
					width="263.969"
					height="267.969"
					filterUnits="userSpaceOnUse"
					color-interpolation-filters="sRGB"
				>
					<feFlood flood-opacity="0" result="BackgroundImageFix" />
					<feColorMatrix
						in="SourceAlpha"
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
						result="hardAlpha"
					/>
					<feOffset dy="8" />
					<feGaussianBlur stdDeviation="2" />
					<feComposite in2="hardAlpha" operator="out" />
					<feColorMatrix
						type="matrix"
						values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.17 0"
					/>
					<feBlend
						mode="normal"
						in2="BackgroundImageFix"
						result="effect1_dropShadow_32_279"
					/>
					<feBlend
						mode="normal"
						in="SourceGraphic"
						in2="effect1_dropShadow_32_279"
						result="shape"
					/>
				</filter>
			</defs>
		</svg>
	);
};
